




import { Component, Vue } from 'vue-property-decorator';
import SubUnitList from '@/components/SubUnit/SubUnitList.vue';

@Component({
  components: {
    SubUnitList,
  },
})
export default class SubUnits extends Vue {}
